import { useRef } from "react";
import { TrashIcon } from "src/lib/ui-icon-v2";
import { IconButtonV2 } from "../IconButtonV2/IconButtonV2.tsx";
import { rootRowStyle, rowPlaceholder } from "./DropZoneInput.style.ts";
import type { ChangeEvent, MouseEvent } from "react";

type RowProps = {
  url?: string;
  imageName: string;
  onRemove(): void;
  onReplace(newFile: File): void;
};

export const PreviewListRow = (props: RowProps) => {
  const { url, imageName, onRemove, onReplace } = props;
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.target.files &&
      event.target.files[0] &&
      onReplace(event.target.files[0]);
  };

  const handleReplaceClick = () => {
    inputRef.current && inputRef.current.click();
  };

  const handleRemove = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onRemove();
  };

  return (
    <div css={rootRowStyle} onClick={handleReplaceClick}>
      <input type="file" hidden ref={inputRef} onChange={handleFileChange} />

      {url && (
        <div
          css={{
            height: "100%",
            width: 44,
            flexShrink: 0,
          }}
        >
          {
            <img
              src={url}
              alt={imageName}
              css={{
                height: "100%",
                width: "100%",
                objectFit: "contain",
              }}
            />
          }
        </div>
      )}

      <span css={rowPlaceholder}>{imageName}</span>

      <IconButtonV2
        size="sm"
        skin="danger"
        variant="outlined"
        type="button"
        css={{ flexShrink: 0 }}
        onClick={handleRemove}
      >
        <TrashIcon />
      </IconButtonV2>
    </div>
  );
};
